import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { OptionEditContainer } from "@/components/features/items/edit/option/standard/default/ui/existing/components/container";

import { useGetOptionEditPageParams } from "./_hooks/use-get-option-edit-page-params";

export const OptionEditPageDefault = () => {
	const { hotelID, optionID } = useGetOptionEditPageParams();
	const activeLangCode = LangCode.Default;
	const navigator = {
		default: generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.DEFAULT, { hotelID, optionID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.I18N, { hotelID, optionID, langCode }),
	};

	return (
		<PageMeta
			title="オプションの詳細"
			url={generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.DEFAULT, { hotelID, optionID })}
		>
			<OptionEditContainer
				hotelID={hotelID}
				optionID={optionID}
				activeLangCode={activeLangCode}
				navigator={navigator}
			/>
		</PageMeta>
	);
};
